module.exports = __webpack_public_path__ + "img/c5.4f1d0cb8.png";